import merge from "lodash/merge";
import { UserOrderRecord } from "./pay"
import { Conference } from "./conference"
import { AttendIdentity } from "./attendidentity"

class Signup {
  constructor() {
    this.id = 0
    this.name = "" //姓名
    this.phone = "" //电话
    this.company = "" //单位
    this.conference_id = "" //会议ID
    this.conference = new Conference() //会议
    this.attendid_id = "" //参会身份ID
    this.attendid = new AttendIdentity() //参会身份
    this.job = "" //职务
    this.email = "" //电子邮箱
    this.stu_code = "" //学生证号
    this.paper_code = "" //论文编号
    this.vip_code = "" //工程会员编号
    this.note = "" //备注
    this.user_id = ""
    this.status = "审核中" //报名状态 审核中，未通过，已完成
    this.paid_order_id = "" // 支付订单id
    this.paid_order = new UserOrderRecord() // 对应支付的订单
    this.paid_status = ""
    this.signinstatus = "" //签到状态
    this.confsites = []
    this.confsiteids = []
    //对公转账人信息
    this.pub_trans_name=""
    this.pub_trans_comp=""
    this.pub_trans_phone=""
    //开票信息 "单位票据","个人票据"
    this.title_type="" 
    this.fplx = "" //发票类型代码 数电专 数电普
    this.ghdwmc = ""  // 购方名称
    this.ghdwmc_search = "" //用于搜索的购方名称，实际上获取的是税号，不会传到后台
    this.ghsjh = ""  // 购方手机号
    this.ghdzyx = ""  // 购方电子邮箱
    this.ghdz = ""  // 购方地址
    this.ghdh = ""  // 购方电话
    this.ghyh = ""  // 购方银行
    this.ghzh = ""  // 购方账号
    this.ghnsrsbh = ""  // 购方纳税人识别号
    this.sfzsxsfyhzh = "否" // 是否展示销售方银行账号
    this.sfzsxsfdzdh = "否" // 是否展示销售方地址电话
    this.sfzsgmfyhzh = "否" // 是否展示购买方银行账号
    this.sfzsgmfdzdh = "否" // 是否展示购买方地址电话

  }
  static getSignupList(filters) {
    const url = process.env.VUE_APP_API_URL + "api/v1/signup"
    if (!filters.per_page || filters.per_page == "") {
      filters.per_page = -1
    }
    return axios.get(url, { params: filters }).then((res) => {
      let result = {}
      result.signup_list = Array()
      res.data.results.forEach((x) => {
        let c = new Signup()
        Object.assign(c, x)
        const paid_order = Object.assign(new UserOrderRecord(), c.paid_order)
        c.paid_order = paid_order
        result.signup_list.push(c)
      })
      result.total = res.data.total
      return result
    })
  }
  createOrUpdateSignup() {
    const url = process.env.VUE_APP_API_URL + "api/v1/signup"
    if (this.id == 0) {
      //新增
      const data = merge({}, this)
      return axios.post(url, data).then((res) => {
        let result = new Signup()
        result = merge(result, res)
        return result
      })
    } else {
      //修改
      const data = merge({}, this)
      return axios.put(url, data).then((res) => {
        let result = new Signup()
        result = merge(result, res)
        return result
      })
    }
  }
  static delete(id) {
    const url = process.env.VUE_APP_API_URL + "api/v1/signup"
    return axios.delete(url, { params: { id: id } }).then((res) => {
      return true
    })
  }
}
export default Signup;
export { Signup };